import {
    fetchCPSCClosedTicketsForMyself
} from '../api/ticketsEndpoints';

/**
 * Determines whether the current user has any CPSC (Cisco) tickets.
 *
 * Used to conditionally expose the "Cisco Archive" header link. As part of the
 * Enterprise Hub migration only CPSC/Cisco tickets remain in SPEAR, and very few
 * users have them, so the link is hidden unless a ticket actually exists.
 * Only closed CPSC tickets are checked — on prod all CPSC tickets are closed.
 *
 * @param {Object} userInfo - User info object from App state
 * @returns {Promise<boolean>} true if the user has at least one closed CPSC ticket
 */
export const hasCiscoTickets = async (userInfo) => {
    const NTID = userInfo?.userNTID;
    if (!NTID) return false;

    const codeLanguage = userInfo?.userLanguage || 'en';

    try {
        const closed = await fetchCPSCClosedTicketsForMyself(NTID, codeLanguage);

        return Array.isArray(closed) && closed.length > 0;
    } catch (error) {
        console.error('Error checking for Cisco tickets:', error);
        return false;
    }
};
